import Vue from 'vue'
import { WebsiteService} from '@/common/api.service'

import {
    FETCH_WEBSITES
} from './actions.type'

import {
    SET_WEBSITES,
    RESET_STATE,
} from './mutations.type'

const initialState = {
    websites: [],
    websitesTotalCount: 0 
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_WEBSITES] (context, payload) {
        return WebsiteService.getWithFilter(payload.filter)
        .then(({ data }) => {
            context.commit(SET_WEBSITES, data)
            return data
        })
    },
}

export const mutations = {
    [SET_WEBSITES] (state, websites) {
        state.websites = websites.data
        state.websitesTotalCount = websites.totalRows;
    },
    [RESET_STATE] () {
        for (let f in state) {
          Vue.set(state, f, initialState[f])
        }
    }
}

const getters = {
    websites (state) {
      return state.websites
    },
    websitesTotalCount (state) {
        return state.websitesTotalCount
    }
  }

export default {
    state,
    actions,
    mutations,
    getters
}